import { render, staticRenderFns } from "./binder-section.vue?vue&type=template&id=b5bbae1c&scoped=true"
import script from "./binder-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./binder-section.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./binder-section.scss?vue&type=style&index=0&id=b5bbae1c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bbae1c",
  null
  
)

export default component.exports